import { Navigate } from "react-router-dom";
import { useEffect, useState, ReactNode } from "react";
import { useUserStore } from "../../stores";

interface RotaProtegidaProps {
  children: ReactNode;
  perfisPermitidos: string[];
}

export function RotaProtegida({ children, perfisPermitidos }: RotaProtegidaProps) {
  const [perfilUsuario, setPerfilUsuario] = useState<string>();
  const [loading, setLoading] = useState(true);

  const { user } = useUserStore();

  useEffect(() => {
    setPerfilUsuario(user?.grupoAcesso?.id.toString());
    setLoading(false);
  }, [user]);

  if (loading) {
    return <div>Carregando...</div>;
  }

  if (!perfilUsuario || !perfisPermitidos.includes(perfilUsuario)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
